import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { authHeader, config, redirectToPdfV2 } from '_helpers';
import { manifestActions, resourceActions, assignmentStatsActions } from '../_actions';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import '../assets/styles/manifest.css';
import '../assets/styles/manifest-modal.css';
import { AlertPopup } from '../_components/AlertPopup';
import EmailManifestModal from '../_components/EmailManifestModal';
import ReactModal from 'react-modal';
import ResourceOrderFormUploader from '_components/ResourceOrderFormUploader/ResourceOrderFormUploader';
import { manifestService } from '_services';
import ResourceOrderForm from 'Docs/Forms/ResourceOrderForm/ResourceOrderForm';
import {
  formatDate,
  formatStandardDate,
  handleErrorResponse,
} from '_helpers/helpers';
import { toast } from 'react-toastify';
import { Vipr } from './Manifest/VIPR';
import { Ncc } from './Manifest/NCC';
import { Project } from './Manifest/Project';
import { Dcrm } from './Manifest/DCRM';
import { Ifca } from './Manifest/IFCA';
import { ManifestFormActions } from './ManifestFormActions';
import { MANIFEST_TYPE } from './constants';
import PropTypes from 'prop-types';
import { ManifestDetailsUpdateModal } from './component/ManifestDetailsUpdateModal';

ReactModal.setAppElement('#app');

const customStyles = {
  content: {
    overflow: 'unset',
  },
  overlay: {
    zIndex: 99,
  },
};

function formatPhoneNumber(s) {
  const s2 = ('' + s).replace(/\D/g, '');
  const m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
  return !m ? null : '(' + m[1] + ')-' + m[2] + '-' + m[3];
}

const RESOURCE_ORDER_FILE_TYPE = {
  CREATE_FORM: 1,
  UPLOADED_FORM: 2,
};

const unDefined = 'undefined';
class Finalize extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resource_id: this.props.match?.params ? this.props.match.params.id : null,
      added_date: null,
      crews: this.props.crews,
      vehicles: this.props.vehicles,
      manifestType: this.props.manifestType?.toString(),
      superintendent: [],
      crewOptions: [],
      vehicleOptions: [],
      mailList: [],
      dispatchMailList: [],
      cclass: 'a' + Math.floor(Math.random() * 60000),
      searchList: [],
      statusOpen: false,
      mdateError: false,
      lastNight: {},
      hideSearch: 'hide',
      rof_type: '',
      rof_id: '',
      sup_name: '',
      h1: this.props.edit ? 'Edit Manifest' : 'Create Manifest',
      form: this.props.form ?? {
        ordering_unit: '',
        incident_name: '',
        incident_number: '',
        resource_number: '',
        resource: '',
        ifca_number: '',
        project_name: '',
        project_code: '',
        dispatch_location: '',
        departure: '',
        report_to: '',
        des_place: '',
        des_eta: '',
        des_etd: '',
        inter_space: '',
        dep_place: '',
        dep_etd: '',
        dep_eta: '',
        inter_eta: '',
        vehicle_number: '',
        dispatch_time: '',
        perssonal: 'Y',
        arr: '',
        dep_time: '',
        dep_arr: '',
        pdep_time: '',
        pedep_place: '',
        highq: [],
        sign_auth_representative: '',
        point_of_hire: '',
        job_loc: '',
      },
      shighq: [],
      print: false,
      email: false,
      submit: false,
      textarea: true,
      search: false,
      saved_id: '',
      printClick: false,
      alertPop: false,
      emailSuccess: '',
      emailLoader: false,
      saveBtn: false,
      validManifestMail: false,
      manifestEmail: '',
      isUpdateStatusModalOpen: false,
      updateStatus: {
        status: 'Committed',
        assignmentType: '',
        manifestId: '',
        manifestName: '',
        incidentName: '',
        location: '',
        complexity: '',
        fuelType: '',
        fireSize: '',
        dateOn: moment(),
        notes: '',
      },
      manifestStatus: null,
      fuelTypes: [],
      fireSizes: [],
      isSubmittingUpdateStatus: false,
      errors: {},
      isSavePendingManifest: false,
      saveActionType: null, // 'commit' or 'pending'
    };
    this.previous = this.previous.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.submitClick = this.submitClick.bind(this);
    this.statusOpenModal = this.statusOpenModal.bind(this);
    this.statusCloseModal = this.statusCloseModal.bind(this);
    this.sendMail = this.sendMail.bind(this);
    this.emailManifest = this.emailManifest.bind(this);
    this.emailChangeFn = this.emailChangeFn.bind(this);
    this.setMailer = this.setMailer.bind(this);
    this.removeList = this.removeList.bind(this);
    this.goBack = this.goBack.bind(this);
    this.printManifest = this.printManifest.bind(this);
    this.onImageError = this.onImageError.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
    this.showAlert = this.showAlert.bind(this);
    this.addManifestEmail = this.addManifestEmail.bind(this);
    this.isValidEmail = this.isValidEmail.bind(this);
    this.handleOnViewResourceOrderForm =
      this.handleOnViewResourceOrderForm.bind(this);
    this.handleDeleteRof = this.handleDeleteRof.bind(this);
    this.saveManifest = this.saveManifest.bind(this);
    this.openUpdateStatusModal = this.openUpdateStatusModal.bind(this);
    this.closeUpdateStatusModal = this.closeUpdateStatusModal.bind(this);
    this.backToEmailModal = this.backToEmailModal.bind(this);
    this.handleUpdateStatusChange = this.handleUpdateStatusChange.bind(this);
    this.loadLatestPendingManifest = this.loadLatestPendingManifest.bind(this);
    this.submitUpdateStatus = this.submitUpdateStatus.bind(this);
    this.savePendingManifestOpenModal =
      this.savePendingManifestOpenModal.bind(this);
  }

  isValidEmail(email) {
    const re = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
    return re.test(email);
  }

  addManifestEmail() {
    if (this.state.validManifestMail) {
      this.setState({
        mailSearchKeyword: '',
        hideSearch: 'hide',
        searchList: [],
        mailList: [
          ...this.state.mailList,
          {
            first_name: '-',
            last_name: '-',
            email: this.state.manifestEmail,
          },
        ],
      });
    }
  }

  previous() {
    this.props.previous(this.state.crews, this.state.form);
  }

  async statusOpenModal() {
    this.setState({
      statusOpen: true,
      print: false,
    });
  }

  async fetchManifestStatus() {
    try {
      const manifestId = this.state.saved_id || this.props.manifest_id;
      if (!manifestId) return;

      const url = config.apiUrl + `/api/manifest/getmanifestinfo`;
      const formData = new FormData();
      formData.append('manifest_id', manifestId);

      const res = await fetch(url, {
        method: 'POST',
        headers: authHeader(),
        body: formData,
      });
      const data = await res.json();

      if (data.success && data.data) {
        const manifestStatus = data.data.manifest_status;
        this.setState({ manifestStatus });
      }
    } catch (error) {
      console.error('Error fetching manifest status:', error);
    }
  }

  handleSaveForInUse(e) {
    // For inuse manifests or edit mode, directly call handleSubmit
    // This will update the manifest and then show the email modal
    this.handleSubmit(e, 'save');
  }

  saveConfirmOpenModal(e) {
    // Otherwise, show the confirmation modal as usual
    return this.setState({
      isSaveConfirmModal: true,
      saveActionType: 'commit',
    });
  }

  savePendingManifestOpenModal(e) {
    return this.setState({
      isSaveConfirmModal: true,
      saveActionType: 'pending',
    });
  }

  goBack() {
    window.location.reload();
    this.setState({ printClick: false });
  }

  showAlert(head, message, alertFunction = null, options = {}) {
    this.setState({
      alertPop: true,
      alertHead: head,
      alertMsg: message,
      alertFunction: alertFunction,
    });
  }

  closeAlert() {
    this.setState({
      alertPop: false,
      statusOpen: false,
    });
  }

  printManifest() {
    const err = this.validate();
    if (err) {
      return;
    }

    this.setState({ printClick: true });
    const data =
      '?manifest_id=' +
      this.state.saved_id +
      '&resource_id=' +
      this.state.resource_id;

    const fdata = new FormData();
    if (this.state.crews.length > 0) {
      let count = 0;
      this.state.crews.map((item, index) => {
        if (item.category === 'oncrew') {
          if (this.state.shighq[item.hash] !== undefined) {
            fdata.append('highq[' + count + ']', this.state.shighq[item.hash]);
          } else {
            fdata.append('highq[' + count + ']', item.incident_pos);
          }
          count++;
        }
        return fdata;
      });
    }

    const requestOptions = {
      method: 'POST',
      headers: authHeader(),
      body: fdata,
    };

    fetch(config.apiUrl + '/api/manifest/pdf' + data, requestOptions)
      .then((res) => res.json())
      .then((data) => {
        redirectToPdfV2(data);
      })
      .catch((error) => {
        console.error('Error fetching PDF manifest:', error);
      });
  }

  onImageError(e) {
    e.target.setAttribute('src', config.apiUrl + '/' + config.altImg);
  }

  validate(e) {
    let isError = false;
    const manifestType = this.state.manifestType;

    const defaultMapping = {
      est_start: {
        errorKey: 'estStartError',
        elementId: 'estStart',
      },
      est_finish: {
        errorKey: 'estFinishError',
        elementId: 'estFinish',
      },
      project_code: {
        errorKey: 'projectCodeError',
        elementId: 'projectCode',
      },
      project_name: {
        errorKey: 'projectNameError',
        elementId: 'projectName',
      },
      resource: {
        errorKey: 'resourceNameError',
        elementId: 'resource',
      },
      point_of_hire: {
        errorKey: 'pointOfHireError',
        elementId: 'pointOfHire',
      },
      job_loc: {
        errorKey: 'jobLocError',
        elementId: 'jobLoc',
      },
      sign_auth_representative: {
        errorKey: 'signError',
        elementId: 'sign',
      },
      pedep_place: {
        errorKey: 'perDepPlaceError',
        elementId: 'perDepPlace',
      },
      pdep_time: {
        errorKey: 'perDepTimeError',
        elementId: 'perDepTime',
      },
      dep_arr: {
        errorKey: 'depArrError',
        elementId: 'depArr',
      },
      dep_time: {
        errorKey: 'depTimeError',
        elementId: 'depTime',
      },
      arr: {
        errorKey: 'arrError',
        elementId: 'arr',
      },
      vehicle_number: {
        errorKey: 'vehNumError',
        elementId: 'uniqVehNumber',
      },
      inter_eta: {
        errorKey: 'interEtaError',
        elementId: 'inter_eta',
      },
      dep_place: {
        errorKey: 'depPlaceError',
        elementId: 'depPlace',
      },
      inter_space: {
        errorKey: 'interSpaceError',
        elementId: 'interSpace',
      },
      des_etd: {
        errorKey: 'desEtdError',
        elementId: 'desETD',
      },
      des_eta: {
        errorKey: 'desEtaError',
        elementId: 'desETA',
      },
      report_to: {
        errorKey: 'reportToError',
        elementId: 'reportTo',
      },
      dispatch_time: {
        errorKey: 'dispatchTimeError',
        elementId: 'dispatchTime',
      },
      dep_eta: {
        errorKey: 'depEtaError',
        elementId: 'desETA',
      },
      dep_etd: {
        errorKey: 'depEtdError',
        elementId: 'desETD',
      },
      des_place: {
        errorKey: 'desPlaceError',
        elementId: 'desPlace',
      },
      dispatch_location: {
        errorKey: 'dispatchError',
        elementId: 'dispatchLocation',
      },
      ifca_number: {
        errorKey: 'ifcaError',
        elementId: 'ifcaNumber',
      },
      resource_number: {
        errorKey: 'resourceError',
        elementId: 'resourceNumber',
      },
      incident_number: {
        errorKey: 'IncidentNumError',
        elementId: 'incidentNumber',
      },
      incident_name: {
        errorKey: 'incidentNameError',
        elementId: 'incidentName',
      },
      ordering_unit: {
        errorKey: 'unitError',
        elementId: 'orderingUnit',
      },
    };

    const manifestTypeKeyMappings = {
      [MANIFEST_TYPE.PROJECT_MANIFEST]: [
        'est_start',
        'est_finish',
        'project_code',
        'project_name',
        'resource',
        'point_of_hire',
        'job_loc',
      ],
      [MANIFEST_TYPE.DCRM]: [
        'est_start',
        'est_finish',
        'incident_number',
        'incident_name',
        'resource',
        'point_of_hire',
        'job_loc',
      ],
      [MANIFEST_TYPE.VIPR]: [
        'sign_auth_representative',
        'pedep_place',
        'pdep_time',
        'dep_arr',
        'dep_time',
        'arr',
        'vehicle_number',
        'dep_place',
        'inter_space',
        'report_to',
        'dispatch_time',
        'ifca_number',
        'resource_number',
        'incident_name',
        'ordering_unit',
      ],
      [MANIFEST_TYPE.NCC]: [
        'inter_eta',
        'dep_place',
        'inter_space',
        'des_etd',
        'des_eta',
        'report_to',
        'dep_etd',
        'des_place',
        'dispatch_location',
        'resource_number',
        'incident_number',
        'incident_name',
        'ordering_unit',
      ],
      [MANIFEST_TYPE.IFCA_Manifest]: [
        'dep_place',
        'inter_space',
        'des_etd',
        'des_eta',
        'report_to',
        'dep_eta',
        'dep_etd',
        'des_place',
        'dispatch_location',
        'ifca_number',
        'resource_number',
        'incident_number',
        'incident_name',
        'ordering_unit',
      ],
      [MANIFEST_TYPE.ODF]: [
        'dep_place',
        'inter_space',
        'des_etd',
        'des_eta',
        'report_to',
        'dep_eta',
        'dep_etd',
        'des_place',
        'dispatch_location',
        'ifca_number',
        'resource_number',
        'incident_number',
        'incident_name',
        'ordering_unit',
      ],
      [MANIFEST_TYPE.TYPE_2]: [
        'dep_place',
        'inter_space',
        'des_etd',
        'des_eta',
        'report_to',
        'dep_etd',
        'des_place',
        'ifca_number',
        'resource_number',
        'incident_number',
        'incident_name',
        'ordering_unit',
      ],
    };

    const mappingKeys = manifestTypeKeyMappings[manifestType];

    const form = this.state.form;
    mappingKeys.forEach((key) => {
      const value = defaultMapping[key];

      if (form[key] === '' || form[key] === undefined) {
        isError = true;
        this.setState({
          errors: {
            ...this.state.errors,
            [value.errorKey]: 'error',
          },
        });

        document
          .getElementById(value.elementId + manifestType)
          .setAttribute('errors', 'error');
      }
    });

    if (this.state.manifestType === MANIFEST_TYPE.PROJECT_MANIFEST) {
      if (
        !this.isValidDate(this.state.form.est_start, this.state.form.est_finish)
      ) {
        isError = true;
        this.setState({
          estStartError: 'error',
          estFinishError: 'error',
        });

        document.getElementById('estStart6').setAttribute('errors', 'error');
        document.getElementById('estFinish6').setAttribute('errors', 'error');
      }

      return isError;
    }

    if (this.state.manifestType === MANIFEST_TYPE.DCRM) {
      if (
        !this.isValidDate(this.state.form.est_start, this.state.form.est_finish)
      ) {
        isError = true;
        this.setState({
          estStartError: 'error',
          estFinishError: 'error',
        });

        document.getElementById('estStart5').setAttribute('errors', 'error');
        document.getElementById('estFinish5').setAttribute('errors', 'error');
      }

      return isError;
    }

    if (this.state.manifestType === MANIFEST_TYPE.VIPR) {
      const start = this.state.eff_start_date;
      const end = this.state.eff_end_date;

      if (!start || !end || !this.isValidDate(start, end)) {
        this.setState({
          mdateError: true,
        });
        isError = true;
      } else {
        this.setState({
          mdateError: false,
        });
      }
    }

    return isError;
  }

  statusCloseModal() {
    this.setState({
      statusOpen: false,
      mailList: [],
      mailSearchKeyword: '',
      searchList: [],
      hideSearch: 'hide',
      textarea: true,
      to: '',
    });
  }

  sendMail(email) {
    this.setState({ to: email, emailSuccess: 'true' }, function () {
      this.emailManifest();
      this.statusCloseModal();
    });
  }

  removeList(index) {
    if (index >= 0) {
      const mailList = this.state.mailList.filter((_, i) => i !== index);

      this.setState({ mailList: mailList, textarea: true, to: '' });
      document.getElementById('txtSearchManiEmployees').value = '';
    }
  }
  removeDispatchList(index) {
    if (index >= 0) {
      const dispatchMailList = this.state.dispatchMailList.filter(
        (_, i) => i !== index,
      );

      this.setState({
        dispatchMailList: dispatchMailList,
        textarea: true,
        to: '',
      });
      document.getElementById('txtSearchManiEmployees').value = '';
    }
  }

  setMailer(item) {
    this.setState({
      textarea: false,
      mailList: [...this.state.mailList, item],
      searchList: [],
      hideSearch: 'hide',
    });
  }

  emailChangeFn(event) {
    const value = event.target.value;

    this.setState(
      {
        mailSearchKeyword: value,
        validManifestMail: false,
      },
      () => {
        clearTimeout(this.state.timeout);
        this.state.timeout = setTimeout(
          function () {
            this.handleSearch(value, true);
          }.bind(this),
          1000,
        );
      },
    );
  }

  handleSearch(text) {
    const data = new FormData();
    data.append('keyword', text);

    const nextState = {
      search: true,
    };

    if (this.isValidEmail(text)) {
      nextState.validManifestMail = true;
      nextState.manifestEmail = text;
    } else {
      nextState.validManifestMail = false;
      nextState.manifestEmail = '';
    }

    // Set search state first to avoid race condition where the
    // response arrives before `search` flag is set and causes no
    // update to the `searchList` UI in componentWillReceiveProps.
    this.setState(nextState, () => {
      this.props
        .dispatch(resourceActions.employeeList(data))
        .then((employee) => {
          try {
            const listData = employee?.data;
            const dataArray =
              listData?.data || (Array.isArray(listData) ? listData : []);
            const empOptions = [];
            if (Array.isArray(dataArray)) {
              dataArray.forEach((item, index) => {
                empOptions.push(
                  <li key={index} onClick={this.setMailer.bind(this, item)}>
                    {item.first_name + ' ' + item.last_name}
                  </li>,
                );
              });
            }

            this.setState({
              searchList: empOptions,
              search: false,
              hideSearch: empOptions.length > 0 ? 'show' : 'hide',
            });
          } catch (err) {
            console.error(
              'Failed to parse employee list in handleSearch promise',
              err,
            );
          }
        })
        .catch((err) => {
          console.error(
            'Finalize.handleSearch -> dispatched employeeList failed',
            err,
          );
        });
    });
  }

  saveManifest(event) {
    this.handleSubmit(event);
  }

  handleSubmit(e, actionType = null) {
    this.setState({
      saveBtn: true,
    });
    e?.preventDefault?.();

    // Extract action type from parameter or event
    const action = actionType || e?.target?.name;

    let isValidDate = true;
    // Check each property in obj for a valid date
    const obj = Object.assign(this.state.lastNight, {});
    Object.entries(obj).forEach(([key, value]) => {
      if (value) {
        // Check if the value matches the MM/DD/YYYY format
        const datePattern =
          /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/(19|20)\d{2}$/;
        if (!datePattern.test(value)) {
          isValidDate = false;
          return;
        }

        // Convert to date and check if it is a valid date
        const dateValue = new Date(value).getTime();
        if (isNaN(dateValue)) {
          isValidDate = false;
          return;
        }
      }
    });

    // Handle the error if any invalid date is found
    if (!isValidDate) {
      return toast.error(
        'The last night not spent on fire assignment field must be a valid date of the format mm/dd/yyyy.',
      );
    }

    if (action === 'save' || action === 'savePending') {
      this.setState({ saveBtn: true });
    }

    if (!this.state.submit || action === 'save' || action === 'savePending') {
      let data = new FormData();

      const manifestId = this.state.saved_id
        ? this.state.saved_id
        : this.props.manifest_id;
      if (this.state.vehicles.length > 0) {
        this.state.vehicles.map((item, index) => {
          const body = {
            id: item.id,
            require_date_on: item.require_date_on,
            date_on: item.date_on,
            require_date_off: item.require_date_off,
            date_off: item.date_off,
            hash: item.hash || null,
          };
          if (item.category === 'selected') {
            data.append('vehicle_no[' + index + ']', JSON.stringify(body));
          } else if (item.category === 'leftout' && manifestId) {
            data.append(
              'leftout_vehicle_no[' + index + ']',
              JSON.stringify(body),
            );
          }

          return data;
        });
      }
      // For IFCA and NCC Manifest only
      if (
        [
          Number(MANIFEST_TYPE.IFCA_Manifest),
          Number(MANIFEST_TYPE.NCC),
          Number(MANIFEST_TYPE.ODF),
          Number(MANIFEST_TYPE.TYPE_2),
        ].includes(Number(this.state.manifestType)) &&
        this.props.contract_number_id != null &&
        this.props.contract_number_id !== ''
      ) {
        data.append('contract_number_id', this.props.contract_number_id);
      }

      this.state.crews?.forEach((item, index) => {
        const body = {
          hash: item.hash,
          require_date_on: item.require_date_on,
          date_on: item.date_on,
          require_date_off: item.require_date_off,
          date_off: item.date_off,
          hotline_shifts: item.hotline_shifts,
        };
        if (item.category === 'oncrew') {
          data.append('user_hash[' + index + ']', JSON.stringify(body));

          if (this.state.shighq[item.hash] !== undefined) {
            data.append('highq[' + index + ']', this.state.shighq[item.hash]);
          } else if (item.incident_pos) {
            data.append('highq[' + index + ']', item.incident_pos);
          } else if (this.state.manifestType === MANIFEST_TYPE.DCRM) {
            data.append('highq[' + index + ']', 'Giss');
          } else if (
            this.state.manifestType === MANIFEST_TYPE.PROJECT_MANIFEST
          ) {
            data.append('highq[' + index + ']', 'Crew Member');
          }

          const val = obj.hasOwnProperty(index.toString())
            ? obj[index.toString()]
            : '';

          data.append('lnnsfa_date' + '[' + index + ']', val);
        } else if (item.category === 'offcrew' && manifestId) {
          data.append('leftout_user_hash[' + index + ']', JSON.stringify(body));
        }
      });

      data.append('resource_id', this.state.resource_id);
      data.append('manifest_id', this.state.manifestType);
      data.append('ordering_unit', this.state.form.ordering_unit);
      data.append('incident_name', this.state.form.incident_name);
      data.append('incident_number', this.state.form.incident_number);
      data.append('resource_number', this.state.form.resource_number);
      data.append('ifca_number', this.state.form.ifca_number);
      data.append('dispatch_location', this.state.form.dispatch_location);
      data.append('report_to', this.state.form.report_to);
      data.append('des_place', this.state.form.des_place);
      data.append('des_eta', this.state.form.des_eta);
      data.append('des_etd', this.state.form.des_etd);
      data.append('inter_space', this.state.form.inter_space);
      data.append('dep_place', this.state.form.dep_place);
      data.append('dep_etd', this.state.form.dep_etd);
      data.append('project_name', this.state.form.project_name);
      data.append('project_code', this.state.form.project_code);
      data.append('job_loc', this.state.form.job_loc);
      data.append('point_of_hire', this.state.form.point_of_hire);
      data.append('rof_type', this.state.rof_type);
      data.append('rof_id', this.state.rof_id);
      if (this.state.form.dep_eta) {
        data.append('dep_eta', this.state.form.dep_eta);
      }

      if (this.state.form.sign_auth_representative?.length > 0) {
        data.append(
          'sign_auth_representative',
          this.state.form.sign_auth_representative,
        );
      }

      // Add Contractor Representative (Superintendent) name
      const superintendentData =
        this.state.superintendent ?? this.props.superintendent.list?.data?.[0];
      if (superintendentData) {
        const { first_name = '', last_name = '' } = superintendentData;
        const contractorRepresentative = `${first_name} ${last_name}`.trim();
        if (contractorRepresentative) {
          data.append('contractor_representative', contractorRepresentative);
        }
      }

      data.append('inter_eta', this.state.form.inter_eta);
      data.append('vehicle_number', this.state.form.vehicle_number);
      data.append('dispatch_time', this.state.form.dispatch_time);
      data.append('perssonal', this.state.form.perssonal);
      data.append('arr', this.state.form.arr);
      data.append('departure', this.state.form.departure);
      data.append('resource', this.state.form.resource);
      data.append('dep_time', this.state.form.dep_time);
      data.append('dep_arr', this.state.form.dep_arr);
      data.append('pdep_time', this.state.form.pdep_time);
      data.append('pedep_place', this.state.form.pedep_place);

      /* Manifest update 23-11-2018 (Siby)*/

      /*Append Effective date from and to */

      data.append(
        'eff_start_date',
        this.convertDateFormat(this.state.eff_start_date),
      );

      data.append(
        'eff_end_date',
        this.convertDateFormat(this.state.eff_end_date),
      );

      /*Append estimated duration */

      data.append(
        'est_start',
        this.convertDateFormat(this.state.form.est_start),
      );

      data.append(
        'est_finish',
        this.convertDateFormat(this.state.form.est_finish),
      );

      // Append manifest_status if saving as pending
      if (this.state.saveActionType === 'pending') {
        data.append('manifest_status', 'pending');
      }

      if (!this.props.edit) {
        if (this.state.saved_id === '') {
          manifestService
            .saveManifest(data)
            .then((response) => {
              this.setState(
                { submit: true, saved_id: response.data.id },
                function () {
                  // If saving as pending, redirect to resource screen
                  if (this.state.saveActionType === 'pending') {
                    toast.success('Manifest saved as pending successfully!');
                    window.location.href = `/resources/${this.state.resource_id}`;
                    return;
                  }

                  if (!this.state.print) {
                    this.statusOpenModal();
                  } else {
                    this.printManifest();
                    setTimeout(this.goBack, 3000);
                  }
                },
              );
            })
            .catch((error) => {
              const parsedError = JSON.parse(error);
              if (parsedError.message) {
                return toast.error(
                  `Error saving manifest: ${parsedError.message}`,
                );
              } else {
                return toast.error('Error saving manifest');
              }
            });
        } else {
          data.append('old_manifest_id', this.state.saved_id);
          manifestService
            .updateManifest(data)
            .then(async (response) => {
              this.setState(
                { submit: true, saved_id: response.data.id },
                async function () {
                  // Execute assignment history updates after manifest update
                  if (this.props.executeAssignmentHistoryUpdates) {
                    await this.props.executeAssignmentHistoryUpdates();
                  }

                  // If saving as pending, redirect to resource screen
                  if (this.state.saveActionType === 'pending') {
                    toast.success('Manifest saved as pending successfully!');
                    window.location.href = `/resources/${this.state.resource_id}`;
                    return;
                  }

                  if (!this.state.print) {
                    this.statusOpenModal();
                  } else {
                    this.printManifest();
                    setTimeout(this.goBack, 3000);
                  }
                },
              );
            })
            .catch((error) => {
              const parsedError = JSON.parse(error);
              if (parsedError.message) {
                return toast.error(
                  `Error saving manifest: ${parsedError.message}`,
                );
              } else {
                return toast.error('Error saving manifest');
              }
            });
        }
      } else {
        if (this.state.saved_id === '') {
          data.append('old_manifest_id', this.props.manifest_id);
        } else {
          data.append('old_manifest_id', this.state.saved_id);
        }
        manifestService
          .updateManifest(data)
          .then(async (response) => {
            this.setState(
              { submit: true, saved_id: response.data.id },
              async function () {
                // Execute assignment history updates after manifest update
                if (this.props.executeAssignmentHistoryUpdates) {
                  await this.props.executeAssignmentHistoryUpdates();
                }

                // If saving as pending, redirect to resource screen
                if (this.state.saveActionType === 'pending') {
                  toast.success('Manifest saved as pending successfully!');
                  window.location.href = `/resources/${this.state.resource_id}`;
                  return;
                }

                if (!this.state.print) {
                  this.statusOpenModal();
                } else {
                  this.printManifest();
                  setTimeout(this.goBack, 3000);
                }
              },
            );
          })
          .catch((error) => {
            const parsedError = JSON.parse(error);
            if (parsedError.message) {
              return toast.error(
                `Error saving manifest: ${parsedError.message}`,
              );
            } else {
              return toast.error('Error saving manifest');
            }
          });
      }
    }
  }

  handleModalConfirmClick(e) {
    e.preventDefault();
    const saveActionType = this.state.saveActionType;
    this.setState({
      isSaveConfirmModal: false,
      saveActionType: saveActionType, // Preserve saveActionType for use in handleSubmit
    });
    const err = this.validate();
    if (err) {
      toast.error('Please fix the validation errors.');
      return;
    }
    // Pass action type directly instead of creating synthetic event
    const action = saveActionType === 'pending' ? 'savePending' : 'save';
    this.handleSubmit(e, action);
  }

  isValidDate(start, end) {
    return moment(end).isAfter(start) || moment(end).isSame(start);
  }

  convertDateFormat(date) {
    if (!date || typeof date === 'undefined') return '';
    try {
      const _date = moment(date).format('MM/DD/YY');
      return _date;
    } catch (er) {
      return '';
    }
  }

  isValidDateFormat(dateString) {
    if (!dateString) return false;
    const datePattern = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
    return datePattern.test(dateString);
  }

  submitClick(e) {
    this.setState({ [e.target.name]: true });
    if (this.state.submit) {
      if (e.target.name === 'print') {
        this.setState({ print: true });
        this.printManifest();
      }
    }
    if (e.target.name === 'email') {
      this.statusOpenModal();
    }
  }

  onChange(e) {
    this.setState({
      form: { ...this.state.form, [e.target.name]: e.target.value },
    });

    e.target.setAttribute('errors', '');
  }

  setNCCDate(hash, dateOrEvent) {
    const obj = { ...this.state.lastNight };

    // Handle both event object (from text input) and date object (from DatePicker)
    if (
      dateOrEvent &&
      dateOrEvent.target &&
      dateOrEvent.target.value !== undefined
    ) {
      obj[hash] = dateOrEvent.target.value;
    } else if (
      dateOrEvent &&
      (dateOrEvent instanceof Date || moment.isMoment(dateOrEvent))
    ) {
      const dateMoment = moment.isMoment(dateOrEvent)
        ? dateOrEvent
        : moment(dateOrEvent);
      obj[hash] = dateMoment.isValid() ? dateMoment.format('MM/DD/YYYY') : '';
    } else {
      obj[hash] = '';
    }

    this.setState({ lastNight: obj }, () => {
      if (
        this.state.manifestType === MANIFEST_TYPE.VIPR &&
        this.state.crews.length > 0
      ) {
        setTimeout(() => {
          this.generateVIPR();
        }, 50);
      }
    });

    return true;
  }

  onSelect(hash, e) {
    const value = e.target.value;
    const shighq = {
      ...this.state.shighq,
      [hash]: value,
    };

    this.setState({ shighq: shighq }, function () {
      if (this.state.manifestType === MANIFEST_TYPE.IFCA_Manifest) {
        this.generateIFCA();
      }
      if (
        this.state.manifestType === MANIFEST_TYPE.NCC ||
        this.state.manifestType === MANIFEST_TYPE.TYPE_2
      ) {
        this.generateNCC();
      }
      if (this.state.manifestType === MANIFEST_TYPE.VIPR) {
        this.generateVIPR();
      }
      if (this.state.manifestType === MANIFEST_TYPE.DCRM) {
        this.generateDCRM();
      }
      if (this.state.manifestType === MANIFEST_TYPE.PROJECT_MANIFEST) {
        this.generatePM();
      }
      if (this.state.manifestType === MANIFEST_TYPE.ODF) {
        this.generateODF();
      }
    });
  }

  componentDidMount() {
    if (this.props.crews) {
      this.props.crews.forEach((item, index) => {
        if (
          item.category == 'oncrew' &&
          item.crew_identifier_id != this.state.resource_id
        ) {
          toast.info(
            `${item.first_name} ${item.last_name} is not currently in this crew.`,
          );
        }
      });
    }
    this.props.dispatch(manifestActions.dispatchMailList());
    this.props.dispatch(assignmentStatsActions.getAssignemntStatusTypes());

    const data = 'resource_id=' + this.state.resource_id;
    if (this.props.edit) {
      this.props.dispatch(manifestActions.getSuperintendent(data));

      const formdata = new FormData();
      formdata.append('manifest_id', this.props.manifest_id);
      this.props.dispatch(manifestActions.manifestDetails(formdata));

      // Fetch manifest status to determine if we should show save button for inuse manifests
      this.fetchManifestStatus();
      return;
    }

    this.props.dispatch(manifestActions.getSuperintendent(data));
    if (this.state.manifestType === MANIFEST_TYPE.IFCA_Manifest) {
      this.generateIFCA();
    }
    if (this.state.manifestType === MANIFEST_TYPE.NCC) {
      this.generateNCC();
    }
    if (this.state.manifestType === MANIFEST_TYPE.VIPR) {
      this.generateVIPR();
    }
    if (this.state.manifestType === MANIFEST_TYPE.DCRM) {
      this.generateDCRM();
    }
    if (this.state.manifestType === MANIFEST_TYPE.PROJECT_MANIFEST) {
      this.generatePM();
    }
    if (this.state.manifestType === MANIFEST_TYPE.ODF) {
      this.generateODF();
    }
    if (this.state.manifestType === MANIFEST_TYPE.TYPE_2) {
      this.generateNCC();
      if (this.props.dispatch_location)
        this.setState({
          form: {
            ...this.state.form,
            dispatch_location: this.props.dispatch_location,
          },
        });
    }
  }

  generateIFCA() {
    if (this.state.crews.length > 0) {
      const options = [];
      let count = 0;
      this.state.crews.map((item, index) => {
        if (item.category === 'oncrew') {
          count++;
          options.push(
            <div className='middle_table tr' key={index}>
              <div
                className='td print_hash_value'
                data-header-title='Crew Member Name'
              >
                <p>
                  {count}. {item.first_name + ' ' + item.last_name}
                </p>
              </div>
              <div className='td print_center em_gender' data-header-title='M'>
                <p>{item.gender === 'Male' ? 'X' : ''}</p>
              </div>
              <div className='td print_center em_gender' data-header-title='F'>
                <p>{item.gender === 'Female' ? 'X' : ''}</p>
              </div>
              <div
                className='td print_center'
                data-header-title='Crew Member Number'
              >
                <p>{item.ica_number}</p>
              </div>
              <div
                className='td print_center'
                data-header-title='Incident Position'
              >
                {item.incident_pos}
              </div>
              <div
                className='td print_center Sawyer'
                data-header-title='Sawyer'
              >
                <p>{item.sawyer ? 'X' : ''}</p>
              </div>
              <div className='td print_center emt' data-header-title='EMT'>
                <p>{item.certified_emt === 'Yes' ? 'X' : ''}</p>
              </div>
              <div
                className='td print_center bry'
                data-header-title='Experience and Lsa (Blue-Red-Yellow)'
              >
                <p>{item.experience} </p>
              </div>
            </div>,
          );
        }
        return options;
      });

      if (count < 20) {
        for (let i = count; i < 20; i++) {
          count++;
          options.push(
            <div className='middle_table tr' key={'ifca' + i}>
              <div
                className='td print_hash_value'
                data-header-title='Crew Member Name'
              >
                <p>{count}. </p>
              </div>
              <div className='td print_center em_gender' data-header-title='M'>
                <p />
              </div>
              <div className='td print_center em_gender' data-header-title='F'>
                <p />
              </div>
              <div
                className='td print_center'
                data-header-title='Crew Member Number'
              >
                <p />
              </div>
              <div
                className='td print_center'
                data-header-title='Incident Position'
              >
                <p />
              </div>
              <div
                className='td print_center Sawyer'
                data-header-title='Sawyer'
              >
                <p />
              </div>
              <div className='td print_center emt' data-header-title='EMT'>
                <p />
              </div>
              <div
                className='td print_center bry'
                data-header-title='Experience and Lsa (Blue-Red-Yellow)'
              >
                <p />
              </div>
            </div>,
          );
        }
      }
      this.setState({ crewOptions: options });
    }

    if (this.state.vehicles.length > 0) {
      let optionsVeh = [];
      let count = 0;
      this.state.vehicles.map((item, index) => {
        if (item.category === 'selected') {
          count++;
          optionsVeh.push(
            <div className='tr' key={index}>
              <div className='td' data-header-title='Driver Name'>
                <p>{item.first_name + ' ' + item.last_name}</p>
              </div>
              <div className='td' data-header-title='License Number/State'>
                <p>{item.drivers_license}</p>
              </div>
              <div className='td mdate' data-header-title='MSPA Exp. Date'>
                <p>{formatDate(item.mspa_exp_date)}</p>
              </div>
              <div className='td' data-header-title='Vehicle Make/Model'>
                <p>{item.vehicle_model_or_make}</p>
              </div>
              <div className='td' data-header-title='Vehicle License No.'>
                <p>
                  {item.vehicle_license === unDefined
                    ? ''
                    : item.vehicle_license}
                </p>
              </div>
            </div>,
          );
        }
        return optionsVeh;
      });
      if (count < 4) {
        for (let i = count; i < 4; i++) {
          count++;
          optionsVeh.push(
            <div className='tr' key={'veh' + i}>
              <div className='td' data-header-title='Driver Name'>
                <p />
              </div>
              <div className='td' data-header-title='License Number/State'>
                <p />
              </div>
              <div className='td mdate' data-header-title='MSPA Exp. Date'>
                <p />
              </div>
              <div className='td' data-header-title='Vehicle Make/Model'>
                <p />
              </div>
              <div className='td' data-header-title='Vehicle License No.'>
                <p />
              </div>
            </div>,
          );
        }
      }
      this.setState({ vehicleOptions: optionsVeh });
    }
  }

  generateODF() {
    if (this.state.crews.length > 0) {
      let options = [],
        count = 0;
      this.state.crews.map((item, index) => {
        if (item.category === 'oncrew') {
          count++;
          options.push(
            <div className='middle_table tr' key={index}>
              <div
                className='td print_hash_value'
                data-header-title='Crew Member Name'
              >
                <p>
                  {count}. {item.first_name + ' ' + item.last_name}
                </p>
              </div>
              <div className='td print_center em_gender' data-header-title='M'>
                <p>{item.gender === 'Male' ? 'X' : ''}</p>
              </div>
              <div className='td print_center em_gender' data-header-title='F'>
                <p>{item.gender === 'Female' ? 'X' : ''}</p>
              </div>
              <div
                className='td print_center'
                data-header-title='Crew Member Number'
              >
                <p>{item.ica_number}</p>
              </div>
              <div
                className='td print_center'
                data-header-title='Incident Position'
              >
                {item.incident_pos}
              </div>
              <div
                className='td print_center Sawyer'
                data-header-title='Sawyer'
              >
                <p>{item.sawyer ? 'X' : ''}</p>
              </div>
              <div className='td print_center emt' data-header-title='EMT'>
                <p>{item.certified_emt === 'Yes' ? 'X' : ''}</p>
              </div>
              <div
                className='td print_center bry'
                data-header-title='Experience B-R-Y Blue-Red-Yellow'
              >
                <p>{item.experience} </p>
              </div>
            </div>,
          );
        }
        return options;
      });

      if (count < 20) {
        for (let i = count; i < 20; i++) {
          count++;
          options.push(
            <div className='middle_table tr' key={'ifca' + i}>
              <div
                className='td print_hash_value'
                data-header-title='Crew Member Name'
              >
                <p>{count}. </p>
              </div>
              <div className='td print_center em_gender' data-header-title='M'>
                <p />
              </div>
              <div className='td print_center em_gender' data-header-title='F'>
                <p />
              </div>
              <div
                className='td print_center'
                data-header-title='Crew Member Number'
              >
                <p />
              </div>
              <div
                className='td print_center'
                data-header-title='Incident Position'
              >
                <p />
              </div>
              <div
                className='td print_center Sawyer'
                data-header-title='Sawyer'
              >
                <p />
              </div>
              <div className='td print_center emt' data-header-title='EMT'>
                <p />
              </div>
              <div
                className='td print_center bry'
                data-header-title='Experience B-R-Y Blue-Red-Yellow'
              >
                <p />
              </div>
            </div>,
          );
        }
      }
      this.setState({ crewOptions: options });
    }

    if (this.state.vehicles.length > 0) {
      let optionsVeh = [];
      let count = 0;
      this.state.vehicles.map((item, index) => {
        if (item.category === 'selected') {
          count++;
          optionsVeh.push(
            <div className='tr' key={index}>
              <div className='td' data-header-title='Driver Name'>
                <p>{item.first_name + ' ' + item.last_name}</p>
              </div>
              <div className='td' data-header-title='License Number/State'>
                <p>{item.drivers_license}</p>
              </div>
              <div className='td mdate' data-header-title='MSPA Exp. Date'>
                <p>{formatDate(item.mspa_exp_date)}</p>
              </div>
              <div className='td' data-header-title='Vehicle Make/Model'>
                <p>{item.vehicle_model_or_make}</p>
              </div>
              <div className='td' data-header-title='Vehicle License No.'>
                <p>
                  {item.vehicle_license === unDefined
                    ? ''
                    : item.vehicle_license}
                </p>
              </div>
            </div>,
          );
        }
        return optionsVeh;
      });
      if (count < 4) {
        for (let i = count; i < 4; i++) {
          count++;
          optionsVeh.push(
            <div className='tr' key={'veh' + i}>
              <div className='td' data-header-title='Driver Name'>
                <p />
              </div>
              <div className='td' data-header-title='License Number/State'>
                <p />
              </div>
              <div className='td mdate' data-header-title='MSPA Exp. Date'>
                <p />
              </div>
              <div className='td' data-header-title='Vehicle Make/Model'>
                <p />
              </div>
              <div className='td' data-header-title='Vehicle License No.'>
                <p />
              </div>
            </div>,
          );
        }
      }
      this.setState({ vehicleOptions: optionsVeh });
    }
  }

  generateNCC() {
    if (this.state.crews.length > 0) {
      let options = [],
        count = 0;
      this.state.crews.map((item, index) => {
        if (item.category === 'oncrew') {
          count++;
          options.push(
            <div className='middle_table tr' key={index}>
              <div
                data-header-title='Employee Name (Last, First)'
                className='print_hash_value td ncc_emp_name'
              >
                <p className='num'>{count}</p>
                <p className='ename'>
                  {item.first_name + ' ' + item.last_name}
                </p>
              </div>
              <div className='print_center gender td' data-header-title='M'>
                <p>{item.gender === 'Male' ? 'X' : ''}</p>
              </div>
              <div className='print_center gender td' data-header-title='F'>
                <p>{item.gender === 'Female' ? 'X' : ''}</p>
              </div>
              <div
                className='print_center td'
                data-header-title='Identification Number'
              >
                <p>{item.fire_id}</p>
              </div>
              <div
                className='print_center td'
                data-header-title='Incident Position'
              >
                {item.incident_pos}
              </div>
              <div
                className='print_center td sawyer'
                data-header-title={
                  this.state.manifestType === MANIFEST_TYPE.TYPE_2
                    ? 'Sawyer'
                    : 'Sawyer Class'
                }
              >
                <p>{item.sawyer ? 'X' : ''}</p>
              </div>
              {this.state.manifestType === MANIFEST_TYPE.TYPE_2 && (
                <div className='td print_center emt' data-header-title='EMT'>
                  <p>{item.certified_emt === 'Yes' ? 'X' : ''}</p>
                </div>
              )}
              <div
                className='print_center td'
                data-header-title={
                  this.state.manifestType === MANIFEST_TYPE.TYPE_2
                    ? 'Experience and LSA (B-R-Y=Blue-Red-Yellow)'
                    : 'Experience Blue-Red-Yellow (B_R_Y)'
                }
              >
                <p>{item.experience.charAt(0)}</p>
              </div>
            </div>,
          );
        }
        return options;
      });
      if (count < 20) {
        for (let i = count; i < 20; i++) {
          count++;
          options.push(
            <div className='tr' key={'manifest' + i}>
              <div
                data-header-title='Employee Name (Last, First)'
                className='print_hash_value td ncc_emp_name'
              >
                <p className='num'>{count}</p>
                <p className='ename' />
              </div>
              <div className='print_center gender td' data-header-title='M'>
                <p />
              </div>
              <div className='print_center gender td' data-header-title='F'>
                <p />
              </div>
              <div
                className='print_center td'
                data-header-title='Identification Number'
              >
                <p />
              </div>
              <div
                className='print_center td'
                data-header-title='Incident Position'
              >
                <p />
              </div>
              <div
                className='print_center td sawyer'
                data-header-title={
                  this.state.manifestType === MANIFEST_TYPE.TYPE_2
                    ? 'Sawyer'
                    : 'Sawyer Class'
                }
              >
                <p />
              </div>
              {this.state.manifestType === MANIFEST_TYPE.TYPE_2 && (
                <div className='td print_center emt' data-header-title='EMT'>
                  <p />
                </div>
              )}
              <div
                className='print_center td'
                data-header-title={
                  this.state.manifestType === MANIFEST_TYPE.TYPE_2
                    ? 'Experience and LSA (B-R-Y=Blue-Red-Yellow)'
                    : 'Experience Blue-Red-Yellow (B_R_Y)'
                }
              >
                <p />
              </div>
            </div>,
          );
        }
      }
      this.setState({ crewOptions: options });
    }

    if (this.state.vehicles.length > 0) {
      let optionsVeh = [];
      let count = 0;
      this.state.vehicles.map((item, index) => {
        if (item.category === 'selected') {
          count++;
          optionsVeh.push(
            <div className='tr' key={index}>
              <div className='td' data-header-title='Driver Name'>
                <p>{item.first_name + ' ' + item.last_name}</p>
              </div>
              {this.state.manifestType === MANIFEST_TYPE.TYPE_2 && (
                <div className='td mdate' data-header-title='MSPA Exp. Date'>
                  <p>{formatDate(item.mspa_exp_date)}</p>
                </div>
              )}
              <div className='td' data-header-title='Vehicle Make/Model'>
                <p>{item.vehicle_model_or_make}</p>
              </div>
              <div className='td st' data-header-title='Year'>
                <p>{item.year}</p>
              </div>
              <div
                className='td exp_date'
                data-header-title='Vehicle License No.'
              >
                <p>
                  {item.vehicle_license === unDefined
                    ? ''
                    : item.vehicle_license}
                </p>
              </div>
            </div>,
          );
        }
        return optionsVeh;
      });

      if (count < 4) {
        for (let i = count; i < 4; i++) {
          count++;
          optionsVeh.push(
            <div className='tr' key={'vehicle' + i}>
              <div className='td' data-header-title='Driver Name'>
                <p />
              </div>
              {this.state.manifestType === MANIFEST_TYPE.TYPE_2 && (
                <div className='td mdate' data-header-title='MSPA Exp. Date'>
                  <p />
                </div>
              )}
              <div className='td' data-header-title='Vehicle Make/Model'>
                <p />
              </div>
              <div className='td st' data-header-title='Year'>
                <p />
              </div>
              <div
                className='td exp_date'
                data-header-title='Vehicle License No.'
              >
                <p />
              </div>
            </div>,
          );
        }
      }
      this.setState({ vehicleOptions: optionsVeh });
    }
  }

  generateVIPR() {
    if (this.state.crews.length > 0) {
      let options = [],
        count = 0;
      this.state.crews.map((item, index) => {
        if (item.category === 'oncrew') {
          count++;
          options.push(
            <div className='tr middle_table' key={index}>
              <div
                className='print_hash_value td'
                data-header-title='Employee Name'
              >
                <p>
                  {count}. {item.first_name + ' ' + item.last_name}
                </p>
              </div>
              <div className='print_center gender td' data-header-title='M'>
                <p>{item.gender === 'Male' ? 'X' : ''}</p>
              </div>
              <div className='print_center gender td' data-header-title='F'>
                <p>{item.gender === 'Female' ? 'X' : ''}</p>
              </div>
              <div className='print_center td' data-header-title='Position'>
                <p>{item.incident_pos}</p>
              </div>
              <div
                className='print_center td'
                data-header-title='LAST NIGHT NOT SPENT ON FIRE ASSIGNMENT (DATE)'
              >
                <div className='lastNightWrapper'>
                  <DatePicker
                    className='lnnsfa_date_date'
                    selected={
                      this.state.lastNight[index]
                        ? moment(
                            this.state.lastNight[index],
                            'MM/DD/YYYY',
                            true,
                          ).isValid()
                          ? moment(
                              this.state.lastNight[index],
                              'MM/DD/YYYY',
                              true,
                            )
                          : null
                        : item.lnnsfa_date && moment(item.lnnsfa_date).isValid()
                          ? moment(item.lnnsfa_date)
                          : null
                    }
                    onChange={(date) => this.setNCCDate(index, date)}
                    dateFormat='MM/DD/YYYY'
                    placeholderText='MM/DD/YYYY'
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode='select'
                  />
                </div>
              </div>
              <div
                className='print_center td'
                data-header-title='UNIQUE EMPLOYEE NUMBER (NO SSN)'
              >
                <p>{item.fire_id}</p>
              </div>
            </div>,
          );
        }
        return options;
      });

      if (count < 6) {
        for (let i = count; i < 6; i++) {
          count++;
          options.push(
            <div className='tr' key={'manifest' + i}>
              <div
                className='print_hash_value td'
                data-header-title='Employee Name'
              >
                <p>{count}. </p>
              </div>
              <div className='print_center gender td' data-header-title='M'>
                <p />
              </div>
              <div className='print_center gender td' data-header-title='F'>
                <p />
              </div>
              <div className='print_center td' data-header-title='Position'>
                <p />
              </div>
              <div
                className='print_center td'
                data-header-title='LAST NIGHT NOT SPENT ON FIRE ASSIGNMENT (DATE)'
              >
                <p />
              </div>
              <div
                className='print_center td'
                data-header-title='UNIQUE EMPLOYEE NUMBER (NO SSN)'
              >
                <p />
              </div>
            </div>,
          );
        }
      }
      this.setState({ crewOptions: options });
    }
  }

  generateDCRM() {
    if (this.state.crews.length > 0) {
      let options = [],
        count = 0;
      this.state.crews.map((item, index) => {
        if (item.category === 'oncrew') {
          count++;
          options.push(
            <div className='middle_table tr' key={index}>
              <div
                className='td print_hash_value'
                data-header-title='Crew Member Name'
              >
                <p>
                  {count}. {item.first_name + ' ' + item.last_name}
                </p>
              </div>
              <div className='td print_center em_gender' data-header-title='M'>
                <p>{item.gender === 'Male' ? 'X' : ''}</p>
              </div>
              <div className='td print_center em_gender' data-header-title='F'>
                <p>{item.gender === 'Female' ? 'X' : ''}</p>
              </div>
              <div
                className='td print_center em_crew_mem_no'
                data-header-title='Employee Id Number'
              >
                <p>{item.fire_id}</p>
              </div>
              <div
                className='td print_center'
                data-header-title='Project Position'
              >
                {item.incident_pos}
              </div>
              <div
                className='td em_phone print_hash_value'
                data-header-title='Phone Number'
              >
                <p>{formatPhoneNumber(item.phone)}</p>
              </div>
            </div>,
          );
        }
        return options;
      });

      if (count < 20) {
        for (let i = count; i < 20; i++) {
          count++;
          options.push(
            <div className='middle_table tr' key={'ifca' + i}>
              <div
                className='td print_hash_value'
                data-header-title='Crew Member Name'
              >
                <p>{count}. </p>
              </div>
              <div className='td print_center em_gender' data-header-title='M'>
                <p />
              </div>
              <div className='td print_center em_gender' data-header-title='F'>
                <p />
              </div>
              <div
                className='td print_center em_crew_mem_no'
                data-header-title='Employee Id Number'
              >
                <p />
              </div>
              <div
                className='td print_center'
                data-header-title='Project Position'
              >
                <p />
              </div>
              <div
                className='td em_phone print_hash_value'
                data-header-title='Phone Number'
              >
                <p></p>
              </div>
            </div>,
          );
        }
      }
      this.setState({ crewOptions: options });
    }

    let optionsVeh = [];
    let count = 0;
    if (this.state.vehicles.length > 0) {
      this.state.vehicles.map((item, index) => {
        if (item.category === 'selected') {
          count++;
          optionsVeh.push(
            <div className='tr' key={index}>
              <div className='td' data-header-title='Driver Name'>
                <p>{item.first_name + ' ' + item.last_name}</p>
              </div>
              <div className='td' data-header-title='License Number/State'>
                <p>{item.drivers_license}</p>
              </div>
              <div
                className='td DLIssued'
                data-header-title='Drivers License Issued State'
              >
                <p>{item.DLState}</p>
              </div>
              <div className='td mdate' data-header-title='MSPA Exp. Date'>
                <p>{formatDate(item.mspa_exp_date)}</p>
              </div>
              <div className='td' data-header-title='Vehicle License No.'>
                <p>
                  {item.vehicle_license === unDefined
                    ? ''
                    : item.vehicle_license}
                </p>
              </div>
            </div>,
          );
        }
        return optionsVeh;
      });
    }
    if (count < 4) {
      for (let i = count; i < 4; i++) {
        count++;
        optionsVeh.push(
          <div className='tr' key={'veh' + i}>
            <div className='td' data-header-title='Driver Name'>
              <p />
            </div>
            <div className='td' data-header-title='License Number/State'>
              <p />
            </div>
            <div
              className='td DLIssued'
              data-header-title='Drivers License Issued State'
            >
              <p />
            </div>
            <div className='td mdate' data-header-title='MSPA Exp. Date'>
              <p />
            </div>
            <div className='td' data-header-title='Vehicle License No.'>
              <p />
            </div>
          </div>,
        );
      }
    }
    this.setState({ vehicleOptions: optionsVeh });
  }

  generatePM() {
    if (this.state.crews.length > 0) {
      let options = [],
        count = 0;
      this.state.crews.map((item, index) => {
        if (item.category === 'oncrew') {
          count++;
          options.push(
            <div className='middle_table tr' key={index}>
              <div
                className='td print_hash_value'
                data-header-title='Crew Member Name'
              >
                <p>
                  {count}. {item.first_name + ' ' + item.last_name}
                </p>
              </div>
              <div className='td print_center em_gender' data-header-title='M'>
                <p>{item.gender === 'Male' ? 'X' : ''}</p>
              </div>
              <div className='td print_center em_gender' data-header-title='F'>
                <p>{item.gender === 'Female' ? 'X' : ''}</p>
              </div>
              <div
                className='td print_center em_crew_mem_no'
                data-header-title='Employee Id Number'
              >
                <p>{item.fire_id}</p>
              </div>
              <div
                className='td print_center'
                data-header-title='Project Position'
              >
                {item.incident_pos}
              </div>
              <div
                className='td em_phone print_hash_value'
                data-header-title='Phone Number'
              >
                <p>{formatPhoneNumber(item.phone)}</p>
              </div>
            </div>,
          );
        }
        return options;
      });

      if (count < 20) {
        for (let i = count; i < 20; i++) {
          count++;
          options.push(
            <div className='middle_table tr' key={'ifca' + i}>
              <div
                className='td print_hash_value'
                data-header-title='Crew Member Name'
              >
                <p>{count}. </p>
              </div>
              <div className='td print_center em_gender' data-header-title='M'>
                <p />
              </div>
              <div className='td print_center em_gender' data-header-title='F'>
                <p />
              </div>
              <div
                className='td print_center em_crew_mem_no'
                data-header-title='Employee Id Number'
              >
                <p />
              </div>
              <div
                className='td print_center'
                data-header-title='Project Position'
              >
                <p />
              </div>
              <div
                className='td em_phone print_hash_value'
                data-header-title='Phone Number'
              >
                <p></p>
              </div>
            </div>,
          );
        }
      }
      this.setState({ crewOptions: options });
    }

    if (this.state.vehicles.length > 0) {
      let optionsVeh = [];
      let count = 0;
      this.state.vehicles.map((item, index) => {
        if (item.category === 'selected') {
          count++;
          optionsVeh.push(
            <div className='tr' key={index}>
              <div className='td' data-header-title='Driver Name'>
                <p>{item.first_name + ' ' + item.last_name}</p>
              </div>
              <div className='td' data-header-title='License Number/State'>
                <p>{item.drivers_license}</p>
              </div>
              <div
                className='td DLIssued'
                data-header-title='Drivers License Issued State'
              >
                <p>{item.DLState}</p>
              </div>
              <div className='td mdate' data-header-title='MSPA Exp. Date'>
                <p>{formatDate(item.mspa_exp_date)}</p>
              </div>
              <div className='td' data-header-title='Vehicle License No.'>
                <p>
                  {item.vehicle_license === unDefined
                    ? ''
                    : item.vehicle_license}
                </p>
              </div>
            </div>,
          );
        }
        return optionsVeh;
      });

      if (count < 4) {
        for (let i = count; i < 4; i++) {
          count++;
          optionsVeh.push(
            <div className='tr' key={'veh' + i}>
              <div className='td' data-header-title='Driver Name'>
                <p />
              </div>
              <div className='td' data-header-title='License Number/State'>
                <p />
              </div>
              <div
                className='td DLIssued'
                data-header-title='Drivers License Issued State'
              >
                <p />
              </div>
              <div className='td mdate' data-header-title='MSPA Exp. Date'>
                <p />
              </div>
              <div className='td' data-header-title='Vehicle License No.'>
                <p />
              </div>
            </div>,
          );
        }
      }
      this.setState({ vehicleOptions: optionsVeh });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { superintendent, manifest, employee } = nextProps;
    if (superintendent.list?.data?.length > 0) {
      this.setState({ superintendent: superintendent.list.data[0] });
    }

    if (manifest?.dispatchMailList) {
      this.setState({ dispatchMailList: manifest.dispatchMailList });
    }

    if (manifest.saved) {
      if (manifest.saved.success) {
        this.setState(
          { submit: true, saved_id: manifest.saved.data.id },
          function () {
            if (this.state.print) {
              this.printManifest();
              setTimeout(this.goBack, 3000);
              return;
            }
          },
        );
      } else {
        this.showAlert('Error', manifest.saved.message);
      }
    }

    if (
      (this.state.search ||
        (this.state.mailSearchKeyword &&
          this.state.mailSearchKeyword.length > 0)) &&
      employee?.list
    ) {
      let empOptions = [];
      const listData = employee?.list?.data;
      const dataArray =
        listData?.data || (Array.isArray(listData) ? listData : []);

      if (Array.isArray(dataArray)) {
        dataArray.forEach((item, index) => {
          empOptions.push(
            <li key={index} onClick={this.setMailer.bind(this, item)}>
              {item.first_name + ' ' + item.last_name}
            </li>,
          );
        });
      }

      this.setState({
        searchList: empOptions,
        search: false,
        hideSearch: empOptions.length > 0 ? 'show' : 'hide',
      });
    }

    if (manifest.list?.success) {
      const form = manifest.list.data;
      const state = {};

      if (form.added_date) {
        state['added_date'] = form.added_date;
      }

      if (form.eff_end_date) {
        state['eff_end_date'] = moment(form.eff_end_date);
      }

      if (form.eff_start_date) {
        state['eff_start_date'] = moment(form.eff_start_date);
      }

      if (form.est_start) {
        form['est_start'] = moment(form.est_start);
      }

      if (form.est_finish) {
        form['est_finish'] = moment(form.est_finish);
      }

      if (form?.resource_order_form) {
        state.rof_type = form?.resource_order_form?.resource_order_form_type;
        state.rof_id = form?.resource_order_form?.resource_order_form_id;
      }

      if (Object.keys(state).length) {
        this.setState(state);
      }

      this.setState({ ...this.state, ...state, form: form });

      const baseManifestId = form.base_manifest_id.toString();
      this.setState({ manifestType: baseManifestId }, function () {
        if (baseManifestId === MANIFEST_TYPE.IFCA_Manifest) {
          this.generateIFCA();
        }
        if (
          baseManifestId === MANIFEST_TYPE.NCC ||
          baseManifestId === MANIFEST_TYPE.TYPE_2
        ) {
          this.generateNCC();
        }
        if (baseManifestId === MANIFEST_TYPE.VIPR) {
          let obj = {};
          this.state.crews.map((item, index) => {
            obj[index.toString()] = item.lnnsfa_date
              ? moment(item.lnnsfa_date).format('MM/DD/YYYY')
              : '';
          });

          this.setState(
            {
              lastNight: obj,
            },
            () => {
              this.generateVIPR();
            },
          );
        }
        if (baseManifestId === MANIFEST_TYPE.DCRM) {
          this.generateDCRM();
        }
        if (baseManifestId === MANIFEST_TYPE.PROJECT_MANIFEST) {
          this.generatePM();
        }
        if (baseManifestId === MANIFEST_TYPE.ODF) {
          this.generateODF();
        }
      });
    }
  }

  emailManifest() {
    this.setState({ emailLoader: true });
    const data = new FormData();
    if (this.state.crews.length > 0) {
      let count = 0;
      this.state.crews.map((item, index) => {
        if (item.category === 'oncrew') {
          if (this.state.shighq[item.hash] !== undefined) {
            data.append('highq[' + count + ']', this.state.shighq[item.hash]);
          } else {
            data.append('highq[' + count + ']', item.highq);
          }
          count++;
        }
        return data;
      });
    }
    data.append('manifest_id', this.state.saved_id);
    data.append('resource_id', this.state.resource_id);

    let toList = this.state.dispatchMailList;

    if (this.state.mailList.length > 0) {
      toList = [...toList, ...this.state.mailList.map((item) => item.email)];
    }

    data.append('to', toList.join());

    // Close modal immediately - email will be sent in background
    this.setState({
      statusOpen: false,
      emailLoader: false,
      mailList: [],
      mailSearchKeyword: '',
      searchList: [],
      hideSearch: 'hide',
    });

    // Send email in background
    fetch(config.apiUrl + '/api/manifest/email-manifest-and-fire-cards', {
      method: 'POST',
      headers: authHeader(),
      body: data,
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Server error: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        if (data.success) {
          toast.success(data.message);
          this.goBack();
        } else {
          handleErrorResponse(data);
        }
      })
      .catch((error) => {
        toast.error(error.message || 'Failed to send email');
      });
  }

  async loadLatestPendingManifest(manifestId = null) {
    try {
      let url =
        config.apiUrl +
        `/api/v1/manifests/get-latest-pending-manifest?resourceId=${this.state.resource_id}`;

      // If manifestId is provided, include it in the query
      if (manifestId) {
        url += `&manifestId=${manifestId}`;
      }

      const res = await fetch(url, { method: 'GET', headers: authHeader() });
      const json = await res.json();
      const { data } = json || {};
      if (data) {
        this.setState({
          updateStatus: {
            ...this.state.updateStatus,
            manifestId: data?.manifest?.id || manifestId || '',
            manifestName: data?.manifest?.incident_name || '',
            incidentName: data?.manifest?.incident_name || '',
          },
          // Store fuel types and fire sizes from API response
          fuelTypes: data?.fuelTypes || [],
          fireSizes: data?.fireSizes || [],
        });
      }
    } catch (e) {
      // Non-blocking: allow manual entry if fetch fails
      console.error('Failed to load latest draft manifest', e);
    }
  }

  async openUpdateStatusModal() {
    // Check manifest status to determine flow
    try {
      const manifestId = this.state.saved_id || this.props.manifest_id;

      // Use the existing manifest details endpoint to get status
      const url = config.apiUrl + `/api/manifest/getmanifestinfo`;
      const formData = new FormData();
      formData.append('manifest_id', manifestId);

      const res = await fetch(url, {
        method: 'POST',
        headers: authHeader(),
        body: formData,
      });
      const data = await res.json();

      // Check manifest status
      if (data.success && data.data) {
        const manifestStatus = data.data.manifest_status;

        // Store manifest status in state for button text
        this.setState({ manifestStatus });

        // Check if resource has any other manifests with 'inuse' status
        const hasInUseManifest = await this.checkResourceHasInUseManifest();

        if (hasInUseManifest) {
          // Manifest is already in_use - just send email and show success
          this.emailManifest();
          return;
        } else if (manifestStatus === 'draft') {
          // Manifest is newly created (draft) - show Step 2 modal for commit
          this.setState(
            { statusOpen: false, isUpdateStatusModalOpen: true },
            () => {
              this.loadLatestPendingManifest(manifestId);
            },
          );
          return;
        }
      }
    } catch (error) {
      console.error('Error checking manifest status:', error);
    }

    // Fallback - show commit modal (for unknown status or errors)
    const manifestId = this.state.saved_id || this.props.manifest_id;
    this.setState({ statusOpen: false, isUpdateStatusModalOpen: true }, () => {
      this.loadLatestPendingManifest(manifestId);
    });
  }

  async checkResourceHasInUseManifest() {
    try {
      const url = config.apiUrl + '/api/v1/manifests/listmanifests';
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...authHeader(),
        },
        body: JSON.stringify({
          resourceId: this.state.resource_id,
          perPage: 50, // Get enough manifests to check
          page: 1,
        }),
      });

      const data = await response.json();

      if (data.status === 'success' && data.data && data.data.data) {
        // Check if any manifest has 'inuse' availability status
        const hasInUseManifest = data.data.data.some(
          (manifest) => manifest.manifest_availability === 'inuse',
        );

        return hasInUseManifest;
      }

      return false;
    } catch (error) {
      console.error('Error checking for in-use manifests:', error);
      return false;
    }
  }

  closeUpdateStatusModal() {
    this.setState({ isUpdateStatusModalOpen: false });
  }

  backToEmailModal() {
    this.setState({ isUpdateStatusModalOpen: false, statusOpen: true });
  }

  handleUpdateStatusChange(e) {
    const { name, value } = e.target;
    let normalizedValue;

    if (name === 'assignmentType') {
      normalizedValue = value === '' ? '' : Number(value);
    } else {
      normalizedValue = value;
    }

    this.setState({
      updateStatus: { ...this.state.updateStatus, [name]: normalizedValue },
    });
  }

  async submitDirectUpdate() {
    // Call the old api/manifest/update API directly when manifest is already in_use
    try {
      const manifestId = this.state.saved_id || this.props.manifest_id;
      const url = config.apiUrl + '/api/manifest/update';

      const formData = new FormData();
      formData.append('manifest_id', manifestId);
      formData.append('resource_id', this.state.resource_id);

      const res = await fetch(url, {
        method: 'POST',
        headers: authHeader(),
        body: formData,
      });

      const data = await res.json();

      if (data.success) {
        toast.success('Manifest updated successfully');
        this.goBack();
      } else {
        toast.error(data.message || 'Failed to update manifest');
      }
    } catch (error) {
      console.error('Error updating manifest:', error);
      toast.error('Error updating manifest');
    }
  }

  async submitUpdateStatus(e) {
    e.preventDefault();
    this.setState({ isSubmittingUpdateStatus: true });
    try {
      const payload = {
        manifestId:
          this.state.updateStatus.manifestId ||
          this.state.saved_id ||
          this.props.manifest_id,
        resourceIdentifierId: this.state.resource_id,
        dateOn: this.state.updateStatus.dateOn
          ? moment(this.state.updateStatus.dateOn).format('YYYY-MM-DD')
          : null,
        assignmentType: Number(this.state.updateStatus.assignmentType),
        dateOff: null,
        shifts: null,
        location: this.state.updateStatus.location || null,
        complexity: this.state.updateStatus.complexity || null,
        fuelType: this.state.updateStatus.fuelType || null,
        fireSize: this.state.updateStatus.fireSize || null,
        hotlineShifts: null,
        notes: this.state.updateStatus.notes || null,
      };

      const res = await fetch(
        config.apiUrl + '/api/v1/manifests/commit-manifest',
        {
          method: 'POST',
          headers: { ...authHeader(), 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        },
      );
      const data = await res.json();
      const isOk = data?.status === 'success';
      if (isOk) this.emailManifest();
      const normalizedMsg = (() => {
        const msg = data?.message;
        if (!msg)
          return isOk ? 'Manifest committed.' : 'Failed to commit manifest';
        if (typeof msg === 'string') return msg;
        if (Array.isArray(msg)) return msg.join(', ');
        if (typeof msg === 'object') {
          try {
            // Laravel validation style: { field: [messages] }
            return Object.entries(msg)
              .map(([key, val]) => {
                if (Array.isArray(val)) return `${key}: ${val.join(', ')}`;
                if (typeof val === 'object')
                  return `${key}: ${JSON.stringify(val)}`;
                return `${key}: ${String(val)}`;
              })
              .join('\n');
          } catch (e) {
            return JSON.stringify(msg);
          }
        }
        return String(msg);
      })();
      this.setState({
        isUpdateStatusModalOpen: false,
        isSubmittingUpdateStatus: false,
      });
      this.showAlert(isOk ? 'Success' : 'Error', normalizedMsg, this.goBack);
    } catch (err) {
      this.setState({
        isUpdateStatusModalOpen: false,
        isSubmittingUpdateStatus: false,
      });
      this.showAlert('Error', 'Failed to commit manifest');
    }
  }

  handleManifestDate(key, date) {
    let obj = {};
    obj[key] = date;
    this.setState(obj, () => {
      this.setState({
        mdateError: !this.isValidDate(
          this.state.eff_start_date,
          this.state.eff_end_date,
        ),
      });
    });
  }
  handleEstimateDates(key, date) {
    this.setState({ form: { ...this.state.form, [key]: date } });
    document
      .getElementsByName(key)
      .forEach((ele) => ele.setAttribute('errors', ''));
  }

  onResourceOrderFormAdded(payload) {
    this.setState({
      rof_id: payload?.rof_id,
      rof_type: payload?.rof_type,
      rofModal: false,
      isCreateResourceOrderForm: false,
      rofFileName: payload?.fileName,
      isEditResourceOrderForm: false,
    });
  }

  printResourceOrderForm() {
    let data = new FormData();
    data.append(
      'manifest_id',
      this.state?.form?.resource_order_form?.manifest_id,
    );
    manifestService
      ?.viewCreatedResourceOrderForm(data)
      .then((response) => redirectToPdfV2(response));
  }

  handleOnViewResourceOrderForm() {
    switch (this.state?.rof_type) {
      case RESOURCE_ORDER_FILE_TYPE?.UPLOADED_FORM:
        window
          .open(this.state?.form?.resource_order_form?.file_link, '_blank')
          .focus();
        break;
      case RESOURCE_ORDER_FILE_TYPE?.CREATE_FORM:
        this?.printResourceOrderForm();
        break;
    }
  }

  handleOnCreateResourceOrderForm() {
    this.setState({ isCreateResourceOrderForm: true });
  }
  handleDeleteRof() {
    this.setState({ isDeleteModalOpen: true });
  }

  handleEditRof = () => {
    let formData = new FormData();
    formData.append('rof_id', this.state.rof_id);
    const defaultValues = manifestService
      ?.getResourceOrderContent(formData)
      .then(({ data }) => {
        if (data) {
          this.setState({
            currentRoData: data?.[0],
            isCreateResourceOrderForm: true,
            isEditResourceOrderForm: true,
          });
        }
      });

    return defaultValues;
  };

  confirmDeleteResourceOrderForm() {
    this.setState({ isResourceOrderFormDeleting: true });
    const manifestId = this.state?.form?.resource_order_form?.manifest_id;
    const clearSubmitPayload =
      this.state?.form?.resource_order_form?.resource_order_form_type ===
        this.state?.rof_type &&
      this.state?.form?.resource_order_form?.resource_order_form_id ===
        this.state?.rof_id;
    if (clearSubmitPayload) {
      const form = { ...this.state?.form };
      delete form.resource_order_form;
      this.setState({ rof_id: '', rof_type: '', form });
    }
    let data = new FormData();
    data.append('manifest_id', manifestId);
    manifestService
      ?.deleteResourceOrderForm(data)
      .then((res) => {
        this.setState({
          isDeleteModalOpen: false,
          isResourceOrderFormDeleting: false,
        });
      })
      .catch((err) => {
        this.setState({
          isDeleteModalOpen: false,
          isResourceOrderFormDeleting: false,
        });
      });
  }

  renderManifestFormActions() {
    const { saveBtn, saved_id, form, manifestStatus } = this.state;
    const { manifest_id, edit } = this.props;
    const showSingleSaveButton = edit || manifestStatus === 'inuse';

    return (
      <ManifestFormActions
        saveBtn={saveBtn}
        previous={this.previous.bind(this)}
        saved_id={saved_id}
        manifest_id={manifest_id}
        handleOnUpload={() => this.setState({ rofModal: true })}
        handleDeleteRof={this.handleDeleteRof}
        handleEditRof={this.handleEditRof}
        handleOnViewResourceOrderForm={this.handleOnViewResourceOrderForm}
        saveConfirmOpenModal={this.saveConfirmOpenModal.bind(this)}
        savePendingManifestOpenModal={this.savePendingManifestOpenModal.bind(
          this,
        )}
        showSingleSaveButton={showSingleSaveButton}
        handleSaveForInUse={this.handleSaveForInUse.bind(this)}
        submitClick={this.submitClick.bind(this)}
        form={form}
        manifestStatus={manifestStatus}
      />
    );
  }

  render() {
    const yourDate = this.state.added_date
      ? new Date(this.state.added_date)
      : new Date();
    const curDate = formatDate(yourDate);

    const form = this.state.form;
    const { superintendent } = this.props;
    const { fuelTypes, fireSizes } = this.state;

    // Determine if we should show single Save button (for edit mode or inuse status)
    const showSingleSaveButton =
      this.props.edit || this.state.manifestStatus === 'inuse';

    let sup_name, sphone;
    if (superintendent.list?.data?.[0]) {
      const data = superintendent.list.data[0];
      sphone = formatPhoneNumber(data.phone);

      const fname = data.first_name ?? '';
      const lname = data.last_name ?? '';
      sup_name = lname !== '' ? fname + ' ' + lname : '-';
    }

    const manifestFormActions = this.renderManifestFormActions();

    return (
      <div className='finalize_manifest'>
        <div className='breadcrumbs'>
          <Link to={'/resources'} className='green'>
            Resources
          </Link>{' '}
          / <span onClick={this.goBack.bind(this)}>Details</span> / Finalize
          Manifest
        </div>
        {this.state?.isCreateResourceOrderForm ? (
          <ResourceOrderForm
            onSubmit={(data) => this.onResourceOrderFormAdded(data)}
            onCancel={() =>
              this.setState({
                isCreateResourceOrderForm: false,
                isEditResourceOrderForm: false,
              })
            }
            editMode={this.state?.isEditResourceOrderForm}
            rofData={this.state.currentRoData}
          />
        ) : (
          <div className='content_div inner_container'>
            {/* Resource Order Form Uploader */}
            <ReactModal
              style={customStyles}
              isOpen={this.state?.rofModal}
              onClose={() => this.setState({ rofModal: false })}
            >
              <ResourceOrderFormUploader
                resourceId={this.props?.resourceDetails}
                manifestId={this.props.manifest_id}
                onClose={() => this.setState({ rofModal: false })}
                onComplete={(data) => this.onResourceOrderFormAdded(data)}
                onCreate={() => this?.handleOnCreateResourceOrderForm()}
                fromManifestForm
                selectedResources={[]}
              />
            </ReactModal>
            {/* Delete Resourse Order File Remove Alert */}
            <ReactModal
              isOpen={this.state?.isDeleteModalOpen}
              onClose={() => this.setState({ isDeleteModalOpen: false })}
            >
              <div id='statusPopup' className='popupModal'>
                <div className='modal-head'>
                  <h4 className='modal-title'>Delete File</h4>
                </div>
                <div className='modal-body'>
                  <p>
                    The attached resource order will be deleted from this
                    manifest , are you sure want to continue?
                  </p>
                  <div className='resource_order_form_delete_modal_action'>
                    <button
                      disabled={this.state?.isResourceOrderFormDeleting}
                      className='button grey'
                      onClick={() =>
                        this.setState({ isDeleteModalOpen: false })
                      }
                    >
                      Cancel
                    </button>
                    <button
                      disabled={this.state?.isResourceOrderFormDeleting}
                      className='button'
                      onClick={() => this.confirmDeleteResourceOrderForm()}
                    >
                      Confirm
                    </button>
                  </div>
                </div>
              </div>
            </ReactModal>

            {/* Save Manifest  */}
            <ReactModal
              isOpen={this.state?.isSaveConfirmModal}
              onClose={() =>
                this.setState({
                  isSaveConfirmModal: false,
                  saveActionType: null,
                })
              }
            >
              <div id='statusPopup' className='popupModal'>
                <div className='modal-head'>
                  <h4 className='modal-title'>Confirm Action</h4>
                </div>
                <div className='modal-body'>
                  <p>
                    {this.state?.rofFileName ||
                    this.state?.form?.resource_order_form
                      ? `There is a resource order (${
                          this.state?.rofFileName ||
                          this.state?.form?.resource_order_form?.file_name ||
                          ''
                        }) added to this manifest. By confirming, it will save the resource order to the manifest.`
                      : 'There is no resource order added to this manifest, are you sure want to continue?'}
                  </p>
                  <div className='resource_order_form_delete_modal_action'>
                    <button
                      disabled={this.state?.isResourceOrderFormDeleting}
                      className='button grey'
                      onClick={() =>
                        this.setState({
                          isSaveConfirmModal: false,
                          print: false,
                          saveActionType: null,
                        })
                      }
                    >
                      Cancel
                    </button>
                    <button
                      disabled={this.state?.isResourceOrderFormDeleting}
                      name='save'
                      className='button'
                      onClick={(event) => this.handleModalConfirmClick(event)}
                    >
                      Confirm
                    </button>
                  </div>
                </div>
              </div>
            </ReactModal>

            {(this.state.manifestType === MANIFEST_TYPE.IFCA_Manifest ||
              this.state.manifestType === MANIFEST_TYPE.ODF) && (
              <Ifca
                handleSubmit={this.handleSubmit}
                errors={this.state.errors}
                manifestFormActions={manifestFormActions}
                curDate={curDate}
                form={form}
                sup_name={sup_name}
                sphone={sphone}
                crewOptions={this.state.crewOptions}
                vehicleOptions={this.state.vehicleOptions}
                handleOnViewResourceOrderForm={
                  this.handleOnViewResourceOrderForm
                }
                onChange={this.onChange.bind(this)}
                formatDate={formatDate}
                manifestType={this.state.manifestType}
              />
            )}

            {(this.state.manifestType === MANIFEST_TYPE.NCC ||
              this.state.manifestType === MANIFEST_TYPE.TYPE_2) && (
              <Ncc
                handleSubmit={this.handleSubmit}
                errors={this.state.errors}
                manifestFormActions={manifestFormActions}
                eff_end_date={this.state.eff_end_date}
                curDate={curDate}
                form={form}
                sup_name={sup_name}
                sphone={sphone}
                crewOptions={this.state.crewOptions}
                vehicleOptions={this.state.vehicleOptions}
                handleOnViewResourceOrderForm={
                  this.handleOnViewResourceOrderForm
                }
                onChange={this.onChange.bind(this)}
                formatDate={formatDate}
                manifestType={this.state.manifestType}
              />
            )}

            {this.state.manifestType === MANIFEST_TYPE.VIPR && (
              <Vipr
                handleSubmit={this.handleSubmit}
                handleManifestStartDates={this.handleManifestDate.bind(
                  this,
                  'eff_start_date',
                )}
                handleManifestFinishDates={this.handleManifestDate.bind(
                  this,
                  'eff_end_date',
                )}
                errors={this.state.errors}
                manifestFormActions={manifestFormActions}
                eff_end_date={this.state.eff_end_date}
                eff_start_date={this.state.eff_start_date}
                curDate={curDate}
                form={form}
                crewOptions={this.state.crewOptions}
                handleOnViewResourceOrderForm={
                  this.handleOnViewResourceOrderForm
                }
                onChange={this.onChange.bind(this)}
                formatDate={formatDate}
                manifestType={this.state.manifestType}
                resource_id={this.state.resource_id}
              />
            )}

            {/* -------------------------------------------------------------------------------------------------------------------- */}

            {this.state.manifestType === MANIFEST_TYPE.DCRM && (
              <Dcrm
                handleSubmit={this.handleSubmit}
                errors={this.state.errors}
                manifestFormActions={manifestFormActions}
                handleEstimateStartDates={this.handleEstimateDates.bind(
                  this,
                  'est_start',
                )}
                handleEstimateFinishDates={this.handleEstimateDates.bind(
                  this,
                  'est_finish',
                )}
                sup_name={sup_name}
                sphone={sphone}
                curDate={curDate}
                form={form}
                crewOptions={this.state.crewOptions}
                vehicleOptions={this.state.vehicleOptions}
                handleOnViewResourceOrderForm={
                  this.handleOnViewResourceOrderForm
                }
                onChange={this.onChange.bind(this)}
                formatDate={formatDate}
                manifestType={this.state.manifestType}
              />
            )}

            {/* -------------------------------------------------------------------------------------------------------------------- */}

            {this.state.manifestType === MANIFEST_TYPE.PROJECT_MANIFEST && (
              <Project
                handleSubmit={this.handleSubmit}
                errors={this.state.errors}
                manifestFormActions={manifestFormActions}
                handleEstimateStartDates={this.handleEstimateDates.bind(
                  this,
                  'est_start',
                )}
                handleEstimateFinishDates={this.handleEstimateDates.bind(
                  this,
                  'est_finish',
                )}
                sup_name={sup_name}
                sphone={sphone}
                curDate={curDate}
                form={form}
                crewOptions={this.state.crewOptions}
                vehicleOptions={this.state.vehicleOptions}
                handleOnViewResourceOrderForm={
                  this.handleOnViewResourceOrderForm
                }
                onChange={this.onChange.bind(this)}
                formatDate={formatDate}
              />
            )}

            <EmailManifestModal
              isOpen={this.state.statusOpen}
              onClose={this.statusCloseModal.bind(this)}
              dispatchMailList={this.state.dispatchMailList}
              mailList={this.state.mailList}
              searchList={this.state.searchList}
              hideSearch={this.state.hideSearch}
              mailSearchKeyword={this.state.mailSearchKeyword}
              validManifestMail={this.state.validManifestMail}
              onEmailChange={this.emailChangeFn.bind(this)}
              onAddEmail={this.addManifestEmail.bind(this)}
              onRemoveEmail={this.removeList.bind(this)}
              onRemoveDispatchEmail={this.removeDispatchList.bind(this)}
              onSendEmail={this.openUpdateStatusModal.bind(this)}
              emailLoader={this.state.commitManifestLoading}
              buttonText={
                this.state.manifestStatus === 'inuse' ? 'Send Email' : 'Next'
              }
            />
            <ManifestDetailsUpdateModal
              isUpdateStatusModalOpen={this.state.isUpdateStatusModalOpen}
              updateStatus={this.state.updateStatus}
              isSubmittingUpdateStatus={this.state.isSubmittingUpdateStatus}
              fuelTypes={this.state.fuelTypes}
              fireSizes={this.state.fireSizes}
              assignmentTypeOptions={this.props.assignmentStats?.types || []}
              closeUpdateStatusModal={this.closeUpdateStatusModal}
              onImageError={this.onImageError}
              submitUpdateStatus={this.submitUpdateStatus}
              handleUpdateStatusChange={this.handleUpdateStatusChange}
              backToEmailModal={this.backToEmailModal}
            />
          </div>
        )}

        {this.state.alertPop && (
          <AlertPopup
            head={this.state.alertHead}
            message={this.state.alertMsg}
            viewOpen='true'
            alertFunction={this.state.alertFunction}
            close={this.closeAlert.bind(this)}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { superintendent, manifest, employee, email, assignmentStats } = state;
  return {
    superintendent,
    manifest,
    employee,
    email,
    assignmentStats,
  };
}

const connectedResourcePage = withRouter(connect(mapStateToProps)(Finalize));
export { connectedResourcePage as Finalize };

Finalize.propTypes = {
  match: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  resourceDetails: PropTypes.object,
  crews: PropTypes.array,
  vehicles: PropTypes.array,
  manifestType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  form: PropTypes.object,
  previous: PropTypes.func.isRequired,
  edit: PropTypes.bool,
  manifest_id: PropTypes.string,
  contract_number_id: PropTypes.string,
  dispatch_location: PropTypes.string,
  superintendent: PropTypes.object.isRequired,
  manifest: PropTypes.object.isRequired,
  employee: PropTypes.object.isRequired,
  executeAssignmentHistoryUpdates: PropTypes.func,
};
